import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, makeStyles, useTheme } from '@material-ui/core/styles';
import clsx from 'clsx';
import MuiAppBar from '@material-ui/core/AppBar';
import { Toolbar } from '../Toolbar';

const StyledAppBar = withStyles({
    root: {
        backgroundColor: 'none',
        zIndex: 1
    }
})(MuiAppBar);

const useStyles = makeStyles({
    appBar: props => ({
        backgroundColor: 'transparent',
        boxShadow: 'none',
        transition: props.theme.transitions.create(['margin', 'width'], {
            easing: props.theme.transitions.easing.sharp,
            duration: props.theme.transitions.duration.leavingScreen
        })
    }),
    appBarShift: props => ({
        // width: `calc(100% - ${props.drawerWidth}px)`,
        // marginLeft: props.drawerWidth,
        transition: props.theme.transitions.create(['margin', 'width'], {
            easing: props.theme.transitions.easing.easeOut,
            duration: props.theme.transitions.duration.enteringScreen
        })
    })
});

const AppBar = ({ handleDrawerOpen, menuOpen, drawerWidth }) => {
    const theme = useTheme();
    const styleProps = {
        drawerWidth,
        theme
    };
    const classes = useStyles(styleProps);
    return (
        <StyledAppBar
            position='relative'
            className={clsx(classes.appBar, {
                [classes.appBarShift]: menuOpen
            })}
        >
            <Toolbar handleDrawerOpen={handleDrawerOpen} menuOpen={menuOpen} />
        </StyledAppBar>
    );
};

AppBar.propTypes = {
    handleDrawerOpen: PropTypes.func.isRequired,
    menuOpen: PropTypes.bool.isRequired,
    drawerWidth: PropTypes.number.isRequired
};

export { AppBar };
export default AppBar;
